import { render, staticRenderFns } from "./BtnErroComprometimento.vue?vue&type=template&id=0855ea7c"
import script from "./BtnErroComprometimento.vue?vue&type=script&lang=js"
export * from "./BtnErroComprometimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports